module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('DIV', {
    staticClass: "content-wrapper"
  }, [(_vm.serverData.loadingDataStatus.mainCommonData != _vm.serverData.loadingDataStatus.types.LOADED) ? _c('div', {
    staticClass: "loading-text"
  }, [_vm._v("\n  Подождите, загружаются общие данные\n")]) : (_vm.serverData.loadingDataStatus.users != _vm.serverData.loadingDataStatus.types.LOADED) ? _c('div', {
    staticClass: "loading-text"
  }, [_vm._v("\n  Подождите, загружаются данные по пользователям\n")]) : (_vm.user == null) ? _c('div', {
    staticStyle: {
      "width": "100%",
      "float": "left"
    }
  }, [_c('div', {
    on: {
      "click": function($event) {
        _vm.close()
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-arrow-circle-left back-button"
  })]), _vm._v(" "), (_vm.activeUser == null) ? _c('div', {
    staticClass: "usernotfound-text"
  }, [_vm._v("Информация недоступна. Войдите в приложение")]) : _c('div', {
    staticClass: "usernotfound-text"
  }, [_vm._v("Пользователь не найден")])]) : _c('div', {
    staticClass: "user"
  }, [_c('div', {
    staticClass: "user-avatar",
    style: ({
      'background-image': 'url(' + _vm.serverData.imagesGetURL(_vm.user.body.avatar) + ')'
    }),
    on: {
      "click": function($event) {
        _vm.close()
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-arrow-circle-left back-button-over"
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100%",
      "padding": "10px 0 0 0",
      "float": "left"
    }
  }, [_c('div', {
    staticClass: "user-name"
  }, [_vm._v(_vm._s(_vm.user.name))])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100%",
      "padding": "10px 0 0 0",
      "float": "left"
    }
  }, [_c('div', {
    staticClass: "user-prop"
  }, [_vm._v(_vm._s(_vm.serverData.appSettings.common.userGroupsMap[_vm.user.group].memberName))])]), _vm._v(" "), (_vm.isActiveUserAdmin()) ? _c('div', {
    staticStyle: {
      "width": "100%",
      "padding": "10px 0 0 0",
      "float": "left"
    }
  }, [_c('div', {
    staticClass: "user-prop"
  }, [_vm._v("+" + _vm._s(_vm.user.phone))])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100%",
      "padding": "10px 0 0 0",
      "float": "left"
    }
  }, [_c('div', {
    staticClass: "user-prop-small"
  }, [_vm._v("Зарегистрирован: " + _vm._s(_vm._f("formatDate")(_vm.user.createdAt, 'monthAsWord')))])]), _vm._v(" "), (_vm.user.deleted != 0) ? _c('div', {
    staticStyle: {
      "width": "100%",
      "padding": "10px 0 0 0",
      "float": "left"
    }
  }, [_c('div', {
    staticClass: "user-prop"
  }, [_vm._v("Удален")])]) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-497d49b1","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/User.vue
// module id = 357
// module chunks = 0